// removed by extract-text-webpack-plugin
module.exports = {"binary_tooltip":"_1CCt0KddWEjvsJiL9uWkDo","binary_tooltip_overlay":"_20Oz96AFbGBfHgeriAwldI"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryToolTip/BinaryToolTip.scss
// module id = 2131
// module chunks = 1